import { http } from '@/http';
import { VerifyPaymentResponse } from '@/entities/payment';

export const verifyPayment = (checkoutId: string) =>
  http.get<VerifyPaymentResponse>(`v1/payments/checkout/${checkoutId}`);
